module.exports = __webpack_public_path__ + "static/national-trust-1fb7205a5680bbfba3d1aa8c51ee403e.svg";